
class FbdClassRosterTooltip  {
   eGui;
   init(params) {
      const roster = params.value;
      this.eGui = document.createElement("div");

      if(typeof roster === "object" && roster !== null && Object.keys(roster).length > 0) {
         this.eGui.classList.add("custom-tooltip", "roster-tooltip");
         this.classId = params.data['class_id'];

         let lastSpan = null;
         for (const [st, vals] of Object.entries(roster)) {
            if(lastSpan) {
               const tn = document.createTextNode(', ');
               lastSpan.appendChild(tn);
            }

            const rSpan = document.createElement("span");

            const lk = document.createElement("a");
            lk.innerText = ("student_name" in vals) ? vals['student_name'] : st;
            lk.href = `?class=${this.classId}#${encodeURIComponent(st)}`;

            rSpan.appendChild(lk);
            this.eGui.appendChild(rSpan);

            lastSpan = rSpan;
         }
      }
   }

   getGui() {
      return this.eGui;
   }
}

export default FbdClassRosterTooltip;